import { motion } from "framer-motion";
import * as Icons from "lucide-react";

// ---- Scroll reveal wrapper ----------------------------------------------
export function Reveal({ children, delay = 0, y = 40, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// ---- Section overline heading -------------------------------------------
export function Overline({ children, index }) {
  return (
    <div className="flex items-center gap-3">
      {index && (
        <span className="font-display text-orange-500 text-sm font-bold tabular-nums">
          {index}
        </span>
      )}
      <span className="h-px w-8 bg-orange-500" />
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-orange-500">
        {children}
      </span>
    </div>
  );
}

// ---- Launching Soon badge -----------------------------------------------
export function LaunchBadge({ label = "Launching Soon" }) {
  return (
    <span className="btn-skew bg-zinc-900 border border-orange-500/40 text-orange-500 text-[10px] font-bold uppercase tracking-wider px-3 py-1">
      <span>{label}</span>
    </span>
  );
}

// ---- Skewed industrial button -------------------------------------------
export function SkewButton({ children, variant = "primary", className = "", ...props }) {
  const base =
    "btn-skew px-8 py-4 font-display text-sm font-bold uppercase tracking-wide cursor-pointer disabled:opacity-60";
  const styles =
    variant === "primary"
      ? "bg-[#ff5a00] text-black hover:bg-[#e04f00] hover:shadow-[0_0_40px_-8px_rgba(255,90,0,0.7)]"
      : "border-2 border-zinc-700 bg-transparent text-white hover:border-[#ff5a00] hover:text-[#ff5a00]";
  return (
    <button className={`${base} ${styles} ${className}`} {...props}>
      <span className="flex items-center gap-2">{children}</span>
    </button>
  );
}

// ---- Dynamic lucide icon -------------------------------------------------
export function Icon({ name, ...props }) {
  const Cmp = Icons[name] || Icons.Wrench;
  return <Cmp {...props} />;
}
